import { RadioProps } from 'ui-kit/components/radios/RadioGroup';
import { SelectOption } from 'ui-kit/inputs/AgentNetDropdownSelector';
import foreignTerritories from 'ui-kit/inputs/geo-data/foreign-territory.json';

export enum TransferorType {
  Individual = 'Individual',
  Entity = 'Entity',
  Trust = 'Trust',
}

export const DEFAULT_ENTITY_NAME = 'Unnamed Entity';
export const DEFAULT_INDIVIDUAL_NAME = 'Unnamed Individual';
export const MAX_TRUSTEES = 8;

export const TRANSFEROR_OPTIONS: RadioProps[] = [
  { value: TransferorType.Individual, label: 'Individual', dataTestId: 'fincen-transferor-type-individual-radio' },
  { value: TransferorType.Entity, label: 'Transferor Entity', dataTestId: 'fincen-transferor-type-entity-radio' },
  { value: TransferorType.Trust, label: 'Transferor Trust', dataTestId: 'fincen-transferor-type-trust-radio' },
];

export const TRUSTEE_PERSON_OPTIONS: RadioProps[] = [
  { value: 'individual', label: 'Individual', dataTestId: 'fincen-trustee-person-type-individual-radio' },
  {
    value: 'legalEntity',
    label: 'Trustee that is a Legal Entity',
    dataTestId: 'fincen-trustee-person-type-entity-radio',
  },
];

export enum TrusteePersonType {
  Individual = 'individual',
  LegalEntity = 'legalEntity',
}

export enum AddressType {
  Primary = 'primary',
  Foreign = 'foreign',
}

export const addressTypeOptions = [
  {
    value: AddressType.Primary,
    label: 'Primary U.S. location where entity conducts business',
    name: 'Primary U.S. location where entity conducts business',
  },
  {
    value: AddressType.Foreign,
    label: 'Principal Place of Business (U.S.)',
    name: 'Principal Place of Business (U.S.)',
  },
];

export const REQUIRED_FIELD_MESSAGE = (fieldName: string): string => `${fieldName} is a required field.`;

export const baseIdentificationTypeOptions = [
  { value: 'ein', label: 'EIN', name: 'EIN' },
  { value: 'ssn-itin', label: 'SSN-ITIN', name: 'SSN-ITIN' },
  { value: 'foreignTaxId', label: 'Foreign Tax Identification Number', name: 'Foreign Tax Identification Number' },
  { value: 'foreignPassport', label: 'Foreign Passport', name: 'Foreign Passport' },
  {
    value: 'foreignEntityRegistrationNumber',
    label: 'Foreign Entity Registration Number',
    name: 'Foreign Entity Registration Number',
  },
  { value: 'noIdentification', label: 'No identification available', name: 'No Identification' },
];

import { CountryCode } from '@agentnet/utils';

export const COUNTRY_OPTIONS: SelectOption[] = [
  { value: CountryCode.US, name: 'United States' },
  ...foreignTerritories.map((territory) => ({
    value: territory.abbreviation,
    name: territory.name,
  })),
];

export const FOREIGN_TERRITORY_OPTIONS: SelectOption[] = foreignTerritories.map((territory) => ({
  value: territory.abbreviation,
  name: territory.name,
}));
